import { Api } from "./api.service";

export function getGroups() {
  return Api.get("/group");
}
